import React from "react";
import { styled } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";

const BannerWrapper = styled(Box)(({ theme, placement }) => ({
  display: "flex",
  justifyContent:
    placement === "footer" || placement === "hero" ? "center" : "flex-end",
  width: "100%",
  marginTop: placement === "footer" ? 0 : theme.spacing(2),
  marginBottom: placement === "footer" ? 0 : theme.spacing(0),
  position: "relative",
  zIndex: 12,
}));

const BannerLink = styled("a")(({ theme }) => ({
  display: "inline-flex",
  alignItems: "center",
  gap: theme.spacing(1.5),
  padding: theme.spacing(1.5, 2),
  borderRadius: 18,
  textDecoration: "none",
  backgroundColor: "rgba(255, 255, 255, 0.94)",
  border: `1px solid ${theme.palette.primary.main}`,
  boxShadow: "0 10px 22px rgba(7, 50, 41, 0.15)",
  color: theme.palette.text.dark,
  transition: "transform 0.2s ease, box-shadow 0.2s ease",
  maxWidth: 440,
  width: "100%",
  justifyContent: "center",
  "&:hover": {
    transform: "translateY(-1px)",
    boxShadow: "0 14px 26px rgba(7, 50, 41, 0.2)",
  },
  [theme.breakpoints.down("md")]: {
    width: "100%",
    padding: theme.spacing(1.25, 1.5),
  },
}));

const BannerLogo = styled("img")(({ theme }) => ({
  width: 44,
  height: 44,
  objectFit: "contain",
  borderRadius: 12,
  backgroundColor: theme.palette.secondary.background,
  padding: theme.spacing(0.5),
  flexShrink: 0,
  [theme.breakpoints.down("md")]: {
    width: 36,
    height: 36,
  },
}));

const BannerTitle = styled(Typography)(({ theme }) => ({
  fontFamily: theme.typography.h1.fontFamily,
  fontSize: "1rem",
  fontWeight: 700,
  letterSpacing: "0.5px",
  textTransform: "uppercase",
  color: theme.palette.text.dark,
  textAlign: "center",
  [theme.breakpoints.down("md")]: {
    fontSize: "0.95rem",
  },
}));

export default function PromoBanner({ placement = "inline" }) {
  return (
    <BannerWrapper placement={placement}>
      <BannerLink
        href="https://natali-cars.com/"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Cheap Car rental in Thessaloniki"
      >
        <BannerLogo
          src="/car-rental/favicon.png"
          alt="Car rental logo"
          loading="lazy"
        />
        <BannerTitle variant="h6">Cheap Car rental in Thessaloniki</BannerTitle>
      </BannerLink>
    </BannerWrapper>
  );
}
